<template>
  <div id="content">
    <div class="inner">
      <h1 v-translate>Videa</h1>
    </div>
      <VodVideosListComponent></VodVideosListComponent>
  </div>
</template>

<script>
import VodVideosListComponent from "./VodVideosListComponent.vue";

export default {
  name: "VodVideos",
  components: {
    VodVideosListComponent,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodVideos/VodVideosList.vue